<script setup lang="ts">

export interface ButtonProps {
  href?: string | undefined
  size?: keyof typeof sizes | undefined
  icon?: `i-${string}:${string}` | undefined
  as?: 'span' | 'div' | undefined
}

const sizes = {
  'base': 'py-3.25 px-8 ',
  'sm': 'px-4 py-2'
} satisfies ({ [key: string]: string })

const props = withDefaults(defineProps<ButtonProps>(), {
  size: 'base',
})

</script>

<template>
  <span class="inline-block relative group/button" >
    <component 
      :is="props.as ? props.as : (props.href ? 'a' : 'button')" 
      :href="props.href" 
      :class="[
        sizes[props.size],
        'inline-flex w-full items-center justify-center cursor-pointer relative capitalize isolate border-brand-primary border-2 rounded-full duration-600 ease-in-out overflow-hidden group-hover/button:scale-105 will-change-transform'
      ]"
    >
        <span class="absolute inset-y-0 w-full z-20 flex -translate-x-full group-hover/button:(translate-x-full) duration-1800 ease-in-out will-change-transform" >
          <span class="flex h-full w-20 bg-brand-primary/10 -skew-x-10 -translate-x-4 group-hover/button:(translate-x-0) duration-1800 ease-in-out" ></span>
          <span class="flex h-full w-10 ml-4 bg-brand-primary/10 -skew-x-10" ></span>
        </span>
        <span
          :class="[
            'text-white text-sm font-semibold z-10 text-wrap text-balance text-center sm:text-nowrap',
            props.icon && 'flex items-center justify-center'
          ]"
        >
          <slot />
          <span v-if="props.icon" :class="[props.icon, 'ml-2 bg-white inline-block text-xl mt-.25']" />
      </span>
      <div class="absolute w-full h-full top-0 left-0 z-5">
        <div class="bg-brand-background opacity-70 z-20 w-full h-full rounded-full" />
      </div>
      <div class="bg-brand-gradient w-full h-full left-0 top-0 absolute rounded-full" />
    </component>
    <span 
      :class="[
        'bg-effect-lighting bg-brand-gradient -z-5 opacity-0 group-hover/button:opacity-100 ease-in-out duration-600 pointer-events-none',
        'absolute left-1/2  -translate-x-1/2 top-1/2 -translate-y-1/2',
        'aspect-video w-[175%]',
      ]" 
    />    
  </span>
</template>